/**
 * Cancel the navigation if the full translation suite is active
 */
export default defineNuxtRouteMiddleware(() => {
  if (import.meta.server) {
    return
  }

  const localeStore = useLocaleStore()
  return !(localeStore.translationToolsActive && !isSolWebsite())
})
